module.exports = __webpack_public_path__ + "static/img/2.3bc2d43.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/aboutUs/companys/2.png
// module id = kNbv
// module chunks = 1